<template>
  <div class="crud-detail-deposit-product-fieldset">
    <b-row :class="[{'block-product-add':crud.form.detail_register.editing}]">
      <b-col lg="4">
        <b-row>
          <b-col lg="12" md="12">
            <div class="d-flex align-items-start crud-detail-product-search-row">
              <div class="flex-grow-1 crud-detail-product-search-field">
                <FindObject :key="'products-' + productSearchType + '-' + crud.form.detail_register.forceRenderSelectProduct"
                            render="search"
                            :type="productSearchType"
                            @select-object="loadProducts($event)"
                            @select-objects="loadProductsMultiple($event)"
                            :valueID="crud.form.detail_register.product_id"
                            :where="conditionProductsActive"
                            :extra-filter-data="productSearchExtraFilterData"
                            :multiple="allowMultipleProducts" />
                <div
                  class="detail-deposit-product-stock-control"
                  v-if="crud.form.detail_register.selectedProduct"
                  v-b-tooltip.hover.top
                  :title="productControlsStock(crud.form.detail_register.selectedProduct) ? 'Este producto controla stock' : 'Este producto no controla stock'">
                  <b-badge :variant="productControlsStock(crud.form.detail_register.selectedProduct) ? 'success' : 'secondary'">
                    <AppIcon :name="productControlsStock(crud.form.detail_register.selectedProduct) ? 'inventory_2' : 'block'" />
                    <span>{{ productControlsStock(crud.form.detail_register.selectedProduct) ? 'Controla stock' : 'Sin control stock' }}</span>
                  </b-badge>
                </div>
              </div>
              <b-button v-if="canFilterBySupplier"
                        variant="link"
                        class="list-view-icon-btn crud-detail-product-supplier-toggle"
                        :class="{ 'list-view-icon-btn--active': filterBySupplier }"
                        v-b-tooltip.hover
                        :title="filterBySupplier ? 'Mostrando solo productos de este proveedor. Click para ver todo el catálogo.' : 'Mostrando todo el catálogo. Click para filtrar solo productos de este proveedor.'"
                        @click="filterBySupplier = !filterBySupplier">
                <AppIcon :name="filterBySupplier ? 'upc-scan' : 'building'" :fill="filterBySupplier" />
              </b-button>
            </div>
          </b-col>
          <b-col lg="12" md="12">                          
            <div v-if="!haveOnlyProduct">
              <div v-if="haveColorsWaist">
                <!-- COLOR Y TALLE --> 
                <b-row>
                  <b-col lg="6" md="6" v-if="crud.form.detail_register.opt_color.length>0">
                    <b-form-group label="Color">
                      <v-select :options="crud.form.detail_register.opt_color" 
                                v-model="crud.form.detail_register.color" 
                                placeholder="Color" 
                                :multiple="false" 
                                :select-on-tab="true"
                                @input="selectColorCombinado"></v-select>
                    </b-form-group>
                  </b-col>                            
                  <b-col lg="6" md="6" v-if="crud.form.detail_register.opt_waist.length>0">
                    <b-form-group label="Talle">                                
                      <v-select :options="crud.form.detail_register.opt_waist" 
                                v-model="crud.form.detail_register.waist" 
                                placeholder="Talle" 
                                :multiple="false" 
                                :select-on-tab="true"
                                @input="selectWaistCombinado"></v-select>                      
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div v-else>
                <!-- COLOR -->
                <div v-if="haveOnlyColors">
                  <b-row>
                    <b-col lg="6" md="6">
                      <b-form-group label="Color">
                        <v-select :options="crud.form.detail_register.opt_color" 
                                  v-model="crud.form.detail_register.color" 
                                  placeholder="Color" 
                                  :multiple="false" 
                                  :select-on-tab="true"
                                  @input="selectColorSimple"></v-select>
                      </b-form-group>                              
                    </b-col>
                  </b-row>
                </div>

                <!-- TALLE -->
                <div v-if="haveOnlyWaist">
                  <b-row>
                    <b-col lg="6" md="6">                                
                      <b-form-group label="Talle">
                        <v-select :options="crud.form.detail_register.opt_waist" 
                                  v-model="crud.form.detail_register.waist" 
                                  placeholder="Talle" 
                                  :multiple="false" 
                                  :select-on-tab="true"
                                  @input="selectWaistSimple"></v-select>                      
                      </b-form-group>                              
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>                          
          </b-col>
        </b-row>
      </b-col>
      <b-col lg="8">
        <b-row v-if="crud.form.detail_register.unit_measurement">
          
          <b-col lg="3">
            <b-form-group label="Cantidad">
              <b-input-group size="sm">
                <b-form-input v-model="crud.form.detail_register.quantity" 
                              type="number" 
                              min="0" 
                              step="1.0000" 
                              class="form-control" />        
                              
                <template #append>                  
                  <b-dropdown :text="crud.form.detail_register.unit_measurement.reference" 
                              :title="crud.form.detail_register.unit_measurement.name" 
                              variant="secondary"
                              v-if="Object.keys(arr.equivalences).length">
                    <b-dropdown-item v-for="element in arr.equivalences" 
                                    :key="element.id" 
                                    @click="setUnitMeasurementAlternative(element)">
                      {{element.name}} ({{element.reference}})
                    </b-dropdown-item>
                  </b-dropdown>
                  <b-button v-else size="sm" variant="secondary" :text="crud.form.detail_register.unit_measurement.reference">
                    {{crud.form.detail_register.unit_measurement.reference}} 
                  </b-button>
                </template>                                       
              </b-input-group>
            </b-form-group>
          </b-col> 
          <b-col lg="4" v-if="this.crud.form.detail_register.selectedProduct && requiresOriginLocation">
            <FindObject :key="'deposits-locations-origin-' + crud.form.detail_register.forceRenderSelectProduct"
                        tag="Ubicación Origen"
                        render="search"
                        type="deposits-location" 
                        display="full_reference" 
                        @select-object="loadLocations($event)" 
                        :valueID="crud.form.detail_register.location_id"
                        auto-select-single
                        :where="conditionLocationActive"
                        :orWhere="conditionLocationActiveOR" 
                        :showAllRegister="this.crud.form.detail_register.selectedProduct.depositLocationDetail.length>0"/>             
          </b-col>
          <b-col lg="4" v-if="operation.reference == 'transferencia'">
            <FindObject :key="'deposits-locations-destination-' + crud.form.detail_register.forceRenderSelectProduct"
                        tag="Ubicación Destino"
                        render="search"
                        type="deposits-location" 
                        display="full_reference"
                        @select-object="loadLocationsDestination($event)" 
                        :valueID="crud.form.detail_register.location_destination_id"
                        auto-select-single
                        :where="conditionLocationActive"
                        :showAllRegister="false"/>             
          </b-col>
          <b-col lg="1" class="crud-new-orders-button-add ml-auto d-flex justify-content-end">
            <b-button @click="addItem()" 
                      v-b-tooltip.hover 
                      :variant="crud.form.detail_register.button.variant"
                      :title="crud.form.detail_register.button.title"
                      size="sm">
              <AppIcon :name="crud.form.detail_register.button.icon" />
            </b-button>
          </b-col>

        </b-row>
      </b-col>

      <b-col lg="12" v-if="crud.form.detail_register.editing" class="block-product-add-div">
        <AppIcon name="circle-fill" fill font-scale="2" />
      </b-col>      
    </b-row>
    <b-row class="mt-2">
      <b-col md="12">                  
        <b-table :key="'table_product_' + forceUpdate"
          class="mb-0 app-table app-table--compact crud-order-table-detail"
          responsive="sm"
          :stacked="isMobileViewport ? 'md' : false"
          :hover="true"
          :small="true"
          :fixed="false"
          :items="crud.form.detail"
          :fields="visibleTableDetailNewOrder">
          
          <template v-slot:cell(code)="data">  
            <div v-if="data.item.product">
              {{data.item.product.code}}
            </div>
          </template>  

          <template v-slot:cell(product)="data">  
            <div v-if="data.item.product" class="text-truncate">
              <span v-b-tooltip.hover :title="getProductCellText(data.item)">
                {{data.item.product.name}}
                <span v-if="data.item.product.color">
                  - <i>{{data.item.product.color.name}}</i>
                </span>

                <span v-if="data.item.product.waist && data.item.product.waist.name">
                  - <i>{{data.item.product.waist.name}}</i>
                </span>
              </span>
              <span
                class="detail-deposit-product-table-stock-control"
                :class="productItemControlsStock(data.item) ? 'detail-deposit-product-table-stock-control--active' : 'detail-deposit-product-table-stock-control--inactive'"
                v-b-tooltip.hover
                :title="productItemControlsStock(data.item) ? 'Controla stock' : 'Sin control stock'">
                <AppIcon :name="productItemControlsStock(data.item) ? 'inventory_2' : 'block'" />
              </span>
            </div>
          </template>   

          <template v-slot:cell(quantity)="data">                            
            <b-input-group v-if="allowInlineDetailEdit" size="sm" class="detail-inline-input">
              <b-form-input v-model="data.item.quantity"
                            type="number"
                            min="0.0001"
                            step="0.0001"
                            @change="updateInlineQuantity(data.item)" />
              <b-input-group-append is-text v-if="data.item.unit_measurement">
                {{data.item.unit_measurement.reference}}
              </b-input-group-append>
            </b-input-group>
            <template v-else>
              {{ parseFloat(data.item.quantity).toFixed(4) }}
              <span v-if="data.item.unit_measurement">{{data.item.unit_measurement.reference}}</span>
            </template>
          </template>   

          <template v-slot:cell(price_cost)="data">
            <product-price-cell v-if="allowPurchasePricing && isSimpleProductItem(data.item)"
                                :item="data.item"
                                :supplier-id="operation ? (operation.suppliers_id || 0) : 0"
                                :currency="currency"
                                edit-source="purchaseRemits" />
            <span v-else>{{ formatCurrency(data.item.price_cost || 0) }}</span>
          </template>

          <template v-slot:cell(bulk_cost)="data">
            <b-form-checkbox v-if="isBulkCostEligible(data.item)"
                             v-model="data.item.bulkCostSelected"
                             :disabled="!isBulkCostSelectable(data.item)"
                             v-b-tooltip.hover.right
                             :title="bulkCostSelectionTitle(data.item)"
                             @change="onBulkCostSelectionChange(data.item, $event)"
                             :aria-label="'Seleccionar ' + getProductCellText(data.item) + ' para actualizar el costo'" />
            <span v-else
                  class="text-muted"
                  v-b-tooltip.hover
                  title="El producto debe estar vinculado al proveedor del remito para actualizar su costo en lote">
              <AppIcon name="link" />
            </span>
          </template>
          
          <template v-slot:cell(deposit)="data">                          
            <b-form-select v-if="allowInlineDetailEdit"
                           v-model="data.item.location_id"
                           :options="locationOptions"
                           size="sm"
                           @change="updateInlineLocation(data.item, $event)" />
            <DepositLocationLabel v-else :location="data.item.location" />
          </template>  

          <template v-slot:cell(deposit_destination)="data">                          
            <DepositLocationLabel :location="data.item.location_destination" />
          </template>            

          <template v-slot:cell(f_action)="data">  
            <b-dropdown right 
                        no-caret
                        size="sm" 
                        variant="link"
                        boundary="window"
                        :toggle-class="isMobileViewport ? 'crud-deposit-detail-action-toggle-labeled' : 'app-table-action-toggle'"
                        :disabled="crud.form.detail_register.button.editing">                      
              <template #button-content>
                <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                <span v-if="isMobileViewport">Opciones</span>
              </template>
              <b-dropdown-item @click="editItem(data.item, data.index)">
                <AppIcon name="edit" /> Editar
              </b-dropdown-item>
              <b-dropdown-item @click="deleteItem(data.index)">
                <AppIcon name="delete" class="text-danger" /> Eliminar
              </b-dropdown-item>     
            </b-dropdown>                                
          </template>                    
        </b-table>                  
      </b-col>
    </b-row>
    <div v-if="canBulkUpdateCost && selectedBulkCostItems.length" class="detail-bulk-cost-bar mt-2">
      <span class="detail-bulk-cost-bar__label"><AppIcon name="money" /> Precio de compra</span>
      <app-number-input v-model="bulkCostPrice"
                        size="sm"
                        :decimals="2"
                        placeholder="Precio de compra" />
      <b-button variant="outline-primary"
                size="sm"
                :disabled="bulkCostSaving || !(parseFloat(bulkCostPrice) > 0)"
                v-b-tooltip.hover
                :title="isValidBulkCost ? 'Configurar precios de venta' : 'Ingresá primero un precio de compra mayor a cero'"
                @click="$refs.bulkPricingEditor.open({ items: selectedBulkCostItems, purchasePrice: bulkCostPrice })">
        <AppIcon name="tags" /> Precios de venta
      </b-button>
      <span class="detail-bulk-cost-bar__count">{{ selectedBulkCostItems.length }} seleccionados</span>
      <b-button v-if="isValidBulkCost && !bulkSalesPricingSaved"
                variant="primary"
                size="sm"
                :disabled="!selectedBulkCostItems.length || !isValidBulkCost || bulkCostSaving"
                @click="confirmBulkCost">
        <b-spinner small v-if="bulkCostSaving" class="mr-1" />
        Aplicar solo compra
      </b-button>
    </div>
    <product-pricing-bulk-editor ref="bulkPricingEditor"
                                 :currency="currency"
                                 :save-pricing="saveBulkPricing"
                                 @purchase-price-change="bulkCostPrice = $event"
                                 @prices-saved="onBulkPricesSaved" />
    <b-alert v-if="p79AlertVisible" show variant="info" class="mt-2 mb-0 p79-alert">
      <AppIcon name="info" class="mr-2" />
      Al guardar este remito, <strong>{{ operation && operation.supplier ? operation.supplier.name : 'el proveedor' }}</strong>
      quedará como proveedor principal para los productos que tenga vinculados en costos.
    </b-alert>
  </div>       
</template>

<script>
  import serviceAPI from './services'
  import Helper from '@/handler/helper' 
  import FindObject from '@/components/inc/find/findObject'    
  import Param from '@/config/parameters'
  import ProductPriceCell, { pricingCache } from '@/components/inc/productPricing/productPriceCell'
  import ProductPricingBulkEditor from '@/components/inc/productPricing/productPricingBulkEditor'
  import costsServiceAPI from '@/components/inc/productPricing/services'
  import ErrorHandler from '@/handler/error'

  export default {
    props: {     
      operation: {
        type: [Object, Array],
        default: () => [],        
      },      
      detailEdit: {
        type: [Array, Object],
        default: null,
      },
      allowPurchasePricing: {
        type: Boolean,
        default: false,
      },
      currency: {
        type: String,
        default: 'ARS',
      },
      forceUpdate: {
        type: Number,
        default: 0,
      },
      allowMultipleProducts: {
        type: Boolean,
        default: false,
      },
      allowInlineDetailEdit: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      FindObject,
      ProductPriceCell,
      ProductPricingBulkEditor,
    },
    data: () => {
      return {  
        tableDetailNewOrder : [],           
        crud: {
          form: {
            detail_register: {
              opt_color: [],
              opt_waist: [],
              color: null,
              waist: null,
              quantity: 0,
              quantityOld: 0,      
              product_id: 0,
              product: null,              
              selectedProduct: null,
              selectProduct: null,
              forceRenderSelectProduct: 0,                                   
              unit_measurement: null,
              unit_measurement_id: 0,
              price_cost: 0,
              location: null,
              location_id: 0,
              location_destination: null,
              location_destination_id: 0,   
              purchase_orders_id: 0,
              purchase_orders_detail_id: 0,
              button: {
                icon: 'fa fa-plus',
                title: 'Agreagr Item',
                variant: 'success',
                editing: false
              },                    
              editing: false,     
            },            
            detail: [],                 
          },          
        },    
        arr: {
          equivalences: [],
          defaultLocation: null,
          locations: [],
        },
        isMobileViewport: false,
        filterBySupplier: true,
        bulkCostPrice: '',
        bulkCostSaving: false,
        bulkSalesPricingSaved: false,
      }
    },
    computed: {
      // CONDITIONS SELECT
      canFilterBySupplier() {
        return !!(this.operation && this.operation.suppliers_id)
      },
      productSearchType() {
        return (this.canFilterBySupplier && this.filterBySupplier) ? 'productsBySupplier' : 'products'
      },
      requiresStockControl() {
        return !!(
          this.operation &&
          ['add-manual', 'sub-manual', 'transferencia'].includes(this.operation.reference)
        )
      },
      requiresOriginLocation() {
        return !!(
          this.crud.form.detail_register.selectedProduct &&
          (this.requiresStockControl || this.productControlsStock(this.crud.form.detail_register.selectedProduct))
        )
      },
      productSearchExtraFilterData() {
        var filters = {}
        if(this.requiresStockControl) {
          filters.only_control_stock = true
        }
        if(this.productSearchType == 'productsBySupplier') {
          filters.suppliers_id = this.operation.suppliers_id
        }
        return filters
      },
      conditionProductsActive() {
        return [{field: 'm_products.active', condition: true}];
      },
      conditionLocationActive() {        
        var conditional = []
        conditional.push({field: 'active', condition: true})
        return conditional        
      },
      conditionLocationActiveOR() {        
        var conditional = []
                
        if(this.operation.reference == 'sub-manual' || this.operation.reference == 'transferencia') {
          if(this.crud.form.detail_register.selectedProduct) {
            if(this.crud.form.detail_register.selectedProduct.depositLocationDetail) {
              this.crud.form.detail_register.selectedProduct.depositLocationDetail.forEach(element => {
                if(element.quantity>0) {
                  conditional.push({field: 'id', condition: element.location_id})
                }              
              });
            }
          }
        }

        if(!conditional.length) {          
          if(this.operation.type && this.operation.type.type_balance == '+')
            conditional = [];
          else 
            conditional.push({field: 'id', condition: -1})                
        }        
        
        return conditional
      },      
      getDetailRegisterSupplierProduct() {
        if(!this.crud.form.detail_register.selectedProduct) {
          return null
        }

        if(this.crud.form.detail_register.selectedProduct.source != 'product') {
          return null
        }

        if(this.crud.form.detail_register.selectedProduct.product_purchase) {
          return this.crud.form.detail_register.selectedProduct.product_purchase
        }

        if(this.crud.form.detail_register.selectedProduct.product &&
           this.crud.form.detail_register.selectedProduct.product.product_purchase) {
          return this.crud.form.detail_register.selectedProduct.product.product_purchase
        }

        return null
      },
      isSimpleSelectedProduct() {
        return !!(
          this.crud.form.detail_register.selectedProduct &&
          this.crud.form.detail_register.selectedProduct.source == 'product'
        )
      },
      visibleTableDetailNewOrder() {
        if(this.shouldShowPurchasePricingColumn) {
          return this.tableDetailNewOrder
        }

        return this.tableDetailNewOrder.filter((field) => field.key != 'price_cost')
      },
      shouldShowPurchasePricingColumn() {
        if(!this.allowPurchasePricing) {
          return false
        }

        if(this.isSimpleSelectedProduct) {
          return true
        }

        return this.crud.form.detail.some((item) => this.isSimpleProductItem(item))
      },
      p79AlertVisible() {
        if(!this.allowPurchasePricing) return false
        if(!this.crud.form.detail.length) return false
        if(!this.operation || !this.operation.suppliers_id) return false
        return Helper.hasParametersAccess(Param.P79)
      },      
      shouldWarnLocationWithDifferentProducts() {
        return Helper.hasParametersAccess(Param.P83)
      },
      locationOptions() {
        return this.arr.locations.map((location) => {
          return {value: location.id, text: this.getLocationLabel(location)}
        })
      },
      canBulkUpdateCost() {
        return this.allowPurchasePricing && !!(this.operation && this.operation.suppliers_id)
      },
      selectedBulkCostItems() {
        return this.crud.form.detail.filter((item) => item.bulkCostSelected && this.isBulkCostEligible(item))
      },
      isValidBulkCost() {
        return parseFloat(this.bulkCostPrice) > 0
      },
      bulkSelectionPriceSignature() {
        return this.crud.form.detail.map((item, index) => {
          return index + ':' + (item.bulkCostSelected ? '1' : '0') + ':' + this.toNumber(item.price_cost)
        }).join('|')
      },

      // CONFIGURACION DE PRODUCTO - VARIEDAD
      haveColorsWaist() {
        if(this.crud.form.detail_register.product) {
          if(this.crud.form.detail_register.product.colors_waist.length) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      haveOnlyColors() {     
        if(this.crud.form.detail_register.product) { 
          if( this.crud.form.detail_register.product.colors.length && 
              !this.crud.form.detail_register.product.waist.length && 
              !this.crud.form.detail_register.product.colors_waist.length) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      haveOnlyWaist() {
        if(this.crud.form.detail_register.product) { 
          if( this.crud.form.detail_register.product.waist.length && 
              !this.crud.form.detail_register.product.colors.length &&
              !this.crud.form.detail_register.product.colors_waist.length) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      haveOnlyProduct() {
        if(this.crud.form.detail_register.product) { 
          if( !this.crud.form.detail_register.product.colors.length && 
              !this.crud.form.detail_register.product.waist.length &&
              !this.crud.form.detail_register.product.colors_waist.length) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },  

      // GET COLOR
      getColorWaistUnique() {        
        var arrColorsWaist = []         
        var arrColorsWaistTMP = []                  
        if(this.crud.form.detail_register.product) {          
          this.crud.form.detail_register.product.colors_waist.forEach(element => {
            if(!arrColorsWaistTMP.includes(element.color.id)) {
              arrColorsWaist.push(element)
              arrColorsWaistTMP.push(element.color.id)
            }          
          });       
          return arrColorsWaist
        }       
      },
      getWaistByColor() {                
        var waist = []        
        if(this.crud.form.detail_register.color) {
          if(this.crud.form.detail_register.color.code) {            
            this.crud.form.detail_register.product.colors_waist.forEach(element => {                        
              if(element.color.id == this.crud.form.detail_register.color.code.id) {              
                waist.push(element)
              }
            });
          }
        }
        return waist
      },               
    },
    watch: {
      isMobileViewport() {
        this.configFieldsTable()
      },
      bulkSelectionPriceSignature() {
        this.syncBulkPriceListFromSelection()
      },
      'operation.suppliers_id'(newVal, oldVal) {
        if(oldVal && newVal !== oldVal && this.allowPurchasePricing) {
          this.crud.form.detail = []
          this.$emit('load-detail', [])
        }
      },
    },
    mounted() {
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this.configFieldsTable()
      this.loadItems()
      if(this.allowInlineDetailEdit) {
        this.loadAvailableLocations()
      }
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      getProductCellText(item) {
        if(!item || !item.product) return ''
        var text = item.product.name
        if(item.product.color) {
          text += ' - ' + item.product.color.name
        }
        if(item.product.waist && item.product.waist.name) {
          text += ' - ' + item.product.waist.name
        }
        return text
      },
      configFieldsTable() {
        this.tableDetailNewOrder = []
        this.tableDetailNewOrder.push({key: 'code', label: 'Código', class:"align-middle " + this.alignClass('text-left')})              
        this.tableDetailNewOrder.push({key: 'product', label: 'Producto', class:"align-middle " + this.alignClass('text-left')})              
        this.tableDetailNewOrder.push({key: 'quantity', label: 'Cantidad', class:"align-middle " + this.alignClass('text-center')})                
        if(this.allowPurchasePricing) {
          this.tableDetailNewOrder.push({key: 'price_cost', label: 'Precio compra', class:"align-middle " + this.alignClass('text-right')})
          if(this.operation && this.operation.suppliers_id) {
            this.tableDetailNewOrder.push({
              key: 'bulk_cost',
              label: 'Lote',
              class: 'align-middle text-center text-nowrap',
              thStyle: { width: '74px', minWidth: '74px' },
            })
          }
        }
        this.tableDetailNewOrder.push({key: 'deposit', label: 'Ubicación (Origen)', class:"align-middle " + this.alignClass('text-right')})                

        if(this.operation.reference == 'transferencia') {
          this.tableDetailNewOrder.push({key: 'deposit_destination', label: 'Ubicación (Destino)', class:"align-middle deposit-destination-cell " + this.alignClass('text-right')})
        }
        
        this.tableDetailNewOrder.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle " + this.alignClass('text-right')})
      },
      loadItems() {              
        if(this.detailEdit) {
          this.detailEdit.forEach(element => {            
            var arrItem = {
              product: element.product,
              quantity: parseFloat(element.quantity),
              quantityOld: parseFloat(element.quantity),
              unit_measurement: element.unit_measurement,
              location: element.location,
              location_id: element.location ? element.location.id : 0,
              location_destination: element.location_destination,
              purchase_orders_id: element.purchase_orders_id || 0,
              purchase_orders_detail_id: element.purchase_orders_detail_id || 0,
              bulkCostSelected: false,
            }
            this.applyPurchasePricingToItem(arrItem, element)

            this.crud.form.detail.push(arrItem)

            // Hidrata costo, IVA y listas de venta: la selección masiva exige
            // comparar la configuración real del producto, no datos parciales del remito.
            this.hydrateItemPricingFromCosts(arrItem)
          });

          this.$emit('load-detail', this.crud.form.detail)
        }
      },      
      loadProducts (object) {
        if(object){
          if(this.requiresStockControl && !this.productControlsStock(object)) {
            this.$awn.alert('El producto seleccionado no controla stock y no puede utilizarse en movimientos de depósito')
            this.loadProducts(null)
            return false
          }

          this.crud.form.detail_register.product = object
          this.crud.form.detail_register.product_id = object.id     
          
          this.crud.form.detail_register.color = null
          this.crud.form.detail_register.waist = null
          
          this.crud.form.detail_register.amount = 0
          this.crud.form.detail_register.currency = null 
          this.crud.form.detail_register.opt_color = []
          this.crud.form.detail_register.opt_waist = []
          this.crud.form.detail_register.forceRenderSelectProduct = object.id
          this.crud.form.detail_register.selectedProduct = null   
          this.crud.form.detail_register.selectProduct = null
          this.crud.form.detail_register.unit_measurement = object.unit_measurement_purchase_default
          this.crud.form.detail_register.unit_measurement_id = object.unit_measurement_purchase_default.id                    
                              
          if(object.colors_waist.length) {
            var colorUnique = this.getColorWaistUnique          
            if(colorUnique) {
              colorUnique.forEach(element => {
                this.crud.form.detail_register.opt_color.push({code: element.color, label: element.color.name})
              });
            }
            return false 
          } 
          
          if(object.colors.length) {
            var simpleColorUnique = object.colors          
                        
            if(simpleColorUnique) {              
              simpleColorUnique.forEach(element => {                  
                this.crud.form.detail_register.opt_color.push({code: element.color, label: element.color.name})                
              });              
            }    
            return false                              
          }

          if(object.waist.length) {
            var waistUnique = object.waist

            if(waistUnique) {
              waistUnique.forEach(element => {                  
                this.crud.form.detail_register.opt_waist.push({code: element.waist, label: element.waist.name})
              });
            }
            return false
          }    
          
          if(!object.colors_waist.length && !object.colors.length && !object.waist.length) {            
            this.selectedProduct()                  
          }

          this.loadEquivalences() 

        } else {                    
          this.crud.form.detail_register.product_id = 0                  
          this.crud.form.detail_register.product = null
          
          this.crud.form.detail_register.color = null
          this.crud.form.detail_register.waist = null              
          this.crud.form.detail_register.quantity = 0          
          this.crud.form.detail_register.opt_color = []
          this.crud.form.detail_register.opt_waist = []   
          this.crud.form.detail_register.selectedProduct = null
          this.crud.form.detail_register.selectProduct = null
          this.crud.form.detail_register.unit_measurement = null
          this.crud.form.detail_register.unit_measurement_id = 0
          this.crud.form.detail_register.price_cost = 0
          this.crud.form.detail_register.location = null
          this.crud.form.detail_register.location_id = 0
          this.crud.form.detail_register.location_destination = null
          this.crud.form.detail_register.location_destination_id = 0      
          this.crud.form.detail_register.purchase_orders_id = 0
          this.crud.form.detail_register.purchase_orders_detail_id = 0
          
          this.crud.form.detail_register.button.title = "Agregar Item"
          this.crud.form.detail_register.button.icon = "fa fa-plus"
          this.crud.form.detail_register.button.variant = "success"            
        }
      },    
      loadProductsMultiple(products) {
        var validProducts = (products || []).filter((product) => {
          return product &&
            !(product.colors_waist || []).length &&
            !(product.colors || []).length &&
            !(product.waist || []).length
        })
        var skipped = (products || []).length - validProducts.length

        if(!validProducts.length) {
          this.$awn.info('Los productos con color o talle deben agregarse individualmente')
          return false
        }

        this.getFirstActiveLocation()
          .then((location) => {
            var added = 0
            validProducts.forEach((product) => {
              if(this.addMultipleProduct(product, location)) {
                added++
              }
            })

            if(added) {
              this.$emit('load-detail', this.crud.form.detail)
              this.$awn.success(added + (added == 1 ? ' producto agregado' : ' productos agregados'))
            } else if(!skipped) {
              this.$awn.info('Los productos seleccionados ya estaban cargados en la primera ubicación disponible')
            }
            if(skipped) {
              this.$awn.info(skipped + (skipped == 1 ? ' producto requiere' : ' productos requieren') + ' elegir color o talle y no se agregaron')
            }
          })
          .catch(() => {
            this.$awn.alert('No se pudo obtener la primera ubicación de depósito disponible')
          })
      },
      getFirstActiveLocation() {
        if(this.arr.defaultLocation) {
          return Promise.resolve(this.arr.defaultLocation)
        }
        return this.loadAvailableLocations()
          .then(() => this.arr.defaultLocation)
      },
      loadAvailableLocations() {
        if(this.arr.locations.length) {
          return Promise.resolve(this.arr.locations)
        }
        return serviceAPI.obtenerUbicacionesDeposito({
          filter: '',
          where: [{field: 'active', condition: true}],
          orWhere: [],
        })
        .then((response) => {
          var locations = Array.isArray(response.data) ? response.data : []
          this.arr.locations = locations
          this.arr.defaultLocation = locations.length ? locations[0] : null
          return locations
        })
      },
      getLocationLabel(location) {
        if(!location) return ''
        if(!location.zone || !location.zone.deposit) {
          return location.full_reference || location.reference || location.name || ''
        }
        var depositName = location.zone.deposit.name || location.zone.deposit.reference || ''
        if(location.full_reference && location.full_reference == depositName) {
          return depositName
        }
        var parts = []
        parts.push(depositName)
        parts.push(location.zone.reference || location.zone.name)
        parts.push(location.reference || location.name || 'Ubicación sin nombre')
        return parts.filter(Boolean).join(' / ')
      },
      updateInlineQuantity(item) {
        var quantity = parseFloat(item.quantity)
        item.quantity = quantity > 0 ? quantity : 1
        this.$emit('load-detail', this.crud.form.detail)
      },
      updateInlineLocation(item, locationID) {
        var location = this.arr.locations.find((element) => element.id == locationID) || null
        item.location = this.cloneLocationWithoutContains(location)
        item.location_id = location ? location.id : 0
        this.$emit('load-detail', this.crud.form.detail)
      },
      isBulkCostEligible(item) {
        if(!this.canBulkUpdateCost || !this.isSimpleProductItem(item)) return false
        var supplierProduct = item.selectProduct && item.selectProduct.product_purchase
        return !!(supplierProduct && supplierProduct.id && supplierProduct.suppliers_id == this.operation.suppliers_id)
      },
      getBulkPricingSignature(item) {
        if(!this.isBulkCostEligible(item)) return null
        var product = item.selectProduct || {}
        var supplierProduct = product.product_purchase || {}
        if(!Array.isArray(product.prices)) return null
        var prices = Array.isArray(product.prices) ? product.prices : []
        return JSON.stringify({
          // El precio base de compra puede diferir, pero sus reglas de cálculo
          // deben ser comunes para que el lote sea explicable.
          percentage_discount: this.toNumber(supplierProduct.percentage_discount),
          percentage_discount_1: this.toNumber(supplierProduct.percentage_discount_1),
          percentage_discount_2: this.toNumber(supplierProduct.percentage_discount_2),
          additional: this.toNumber(supplierProduct.additional),
          additional_1: this.toNumber(supplierProduct.additional_1),
          additional_percentage: this.toNumber(supplierProduct.additional_percentage),
          additional_percentage_1: this.toNumber(supplierProduct.additional_percentage_1),
          iva_condition: product.erp_iva_condition_id || product.iva_condition || 0,
          // La utilidad no forma parte de la firma: será reemplazada. Sí importan lista y descuento.
          lists: prices.map(price => ({ id: price.price_list_id, desc: this.toNumber(price.desc) }))
            .sort((a, b) => a.id - b.id),
        })
      },
      isBulkCostSelectable(item) {
        if(item.bulkCostSelected) return true
        if(!this.getBulkPricingSignature(item)) return false
        var selected = this.selectedBulkCostItems
        if(!selected.length) return true
        return this.getBulkPricingSignature(item) == this.getBulkPricingSignature(selected[0])
      },
      bulkCostSelectionTitle(item) {
        if(this.isBulkCostSelectable(item)) return 'Seleccionar para editar precios en lote'
        if(!this.getBulkPricingSignature(item)) return 'Esperando la configuración de precios del producto'
        return 'No se puede seleccionar: su IVA o configuración de listas de venta no coincide con los productos ya seleccionados'
      },
      onBulkCostSelectionChange(item, selected) {
        if(typeof selected === 'boolean') this.$set(item, 'bulkCostSelected', selected)
        this.bulkSalesPricingSaved = false
        if(item.bulkCostSelected) {
          var signature = this.getBulkPricingSignature(item)
          this.crud.form.detail.forEach(detailItem => {
            if(detailItem !== item && detailItem.bulkCostSelected && this.getBulkPricingSignature(detailItem) != signature) {
              this.$set(detailItem, 'bulkCostSelected', false)
            }
          })
        }
        this.$nextTick(() => this.syncBulkPriceListFromSelection())
      },
      syncBulkPriceListFromSelection() {
        var items = this.selectedBulkCostItems
        if(!items.length) {
          this.bulkCostPrice = ''
          return
        }
        var values = items.map(item => this.toNumber(item.price_cost))
        var firstValue = values[0]
        var samePriceList = values.every(value => Math.abs(value - firstValue) < 0.0001)
        this.bulkCostPrice = samePriceList ? firstValue : 0
      },
      confirmBulkCost() {
        if(!this.isValidBulkCost || this.bulkCostSaving) return
        this.$bvModal.msgBoxConfirm(
          'Se actualizará únicamente el precio de lista y el costo de compra de los productos seleccionados. Los precios de venta no se modificarán.',
          { title: 'Confirmar actualización de compra', okTitle: 'Aplicar solo compra', cancelTitle: 'Cancelar', okVariant: 'primary', centered: true }
        ).then(confirmed => {
          if(confirmed) this.applyBulkCost()
        })
      },
      applyBulkCost() {
        var priceCost = parseFloat(this.bulkCostPrice)
        var items = this.selectedBulkCostItems.slice()
        if(!items.length || !(priceCost > 0)) return false

        this.bulkCostSaving = true
        var saved = 0
        var updateNext = (index) => {
          if(index >= items.length) return Promise.resolve()
          var item = items[index]
          var supplierProduct = item.selectProduct.product_purchase
          var priceList = this.getPriceListForCost(supplierProduct, priceCost)
          if(priceList === null) return Promise.reject(new Error('La configuración de descuentos no permite calcular el precio para uno de los productos seleccionados'))
          return costsServiceAPI.updateProducto({
            id: supplierProduct.id,
            product_id: item.selectProduct.id,
            price_list: priceList,
            percentage_discount: supplierProduct.percentage_discount || 0,
            percentage_discount_1: supplierProduct.percentage_discount_1 || 0,
            percentage_discount_2: supplierProduct.percentage_discount_2 || 0,
            additional: supplierProduct.additional || 0,
            additional_1: supplierProduct.additional_1 || 0,
            additional_percentage: supplierProduct.additional_percentage || 0,
            additional_percentage_1: supplierProduct.additional_percentage_1 || 0,
            force_price_update: true,
            edit_source: 'purchaseRemitsBulkCost',
            staff_id: Helper.getStaffId(),
          })
          .then(() => {
            supplierProduct.price_list = priceList
            supplierProduct.price_cost = priceCost
            this.$set(item, 'price_cost', priceCost)
            this.$set(item, 'bulkCostSelected', false)
            delete pricingCache[item.selectProduct.id + ':' + this.operation.suppliers_id]
            saved++
            return updateNext(index + 1)
          })
        }

        updateNext(0)
          .then(() => {
            this.bulkCostPrice = ''
            this.$emit('load-detail', this.crud.form.detail)
            this.$awn.success('Costo actualizado en ' + saved + (saved == 1 ? ' producto' : ' productos'))
          })
          .catch((error) => {
            this.$awn.alert(error && error.message ? error.message : ErrorHandler.showError(error))
          })
          .then(() => {
            this.bulkCostSaving = false
          })
      },
      saveBulkPricing(payload) {
        var priceCost = parseFloat(payload.purchasePrice)
        var items = payload.items || []
        var operations = payload.operations || []
        var updateSales = (index) => {
          if(index >= operations.length) return Promise.resolve()
          var operation = operations[index]
          return costsServiceAPI.editarPrecioListaProducto({
            id: operation.price.id,
            utility: operation.utility,
            desc: operation.price.desc,
            edit_source: 'purchaseRemitsBulkPricing',
            staff_id: Helper.getStaffId(),
          }).then(() => {
            operation.price.utility = operation.utility
            return updateSales(index + 1)
          })
        }

        if(!(priceCost > 0)) return Promise.reject(new Error('Debe ingresar un precio de compra mayor a cero'))

        var updateCosts = (index) => {
          if(index >= items.length) return updateSales(0)
          var item = items[index]
          var supplierProduct = item.selectProduct.product_purchase
          var priceList = this.getPriceListForCost(supplierProduct, priceCost)
          if(priceList === null) return Promise.reject(new Error('La configuración de descuentos no permite calcular el precio para uno de los productos seleccionados'))
          return costsServiceAPI.updateProducto({
            id: supplierProduct.id,
            product_id: item.selectProduct.id,
            price_list: priceList,
            percentage_discount: supplierProduct.percentage_discount || 0,
            percentage_discount_1: supplierProduct.percentage_discount_1 || 0,
            percentage_discount_2: supplierProduct.percentage_discount_2 || 0,
            additional: supplierProduct.additional || 0,
            additional_1: supplierProduct.additional_1 || 0,
            additional_percentage: supplierProduct.additional_percentage || 0,
            additional_percentage_1: supplierProduct.additional_percentage_1 || 0,
            force_price_update: true,
            edit_source: 'purchaseRemitsBulkPricing',
            staff_id: Helper.getStaffId(),
          }).then(() => {
            supplierProduct.price_list = priceList
            supplierProduct.price_cost = priceCost
            this.$set(item, 'price_cost', priceCost)
            delete pricingCache[item.selectProduct.id + ':' + this.operation.suppliers_id]
            return updateCosts(index + 1)
          })
        }
        return updateCosts(0)
      },
      onBulkPricesSaved() {
        this.bulkSalesPricingSaved = true
        this.crud.form.detail.forEach(item => {
          if(item.bulkCostSelected) this.$set(item, 'bulkCostSelected', false)
        })
        this.bulkCostPrice = ''
        this.$emit('load-detail', this.crud.form.detail)
      },
      getPriceListForCost(supplierProduct, priceCost) {
        var value = priceCost - this.toNumber(supplierProduct.additional_1)
        var factors = [
          1 + this.toNumber(supplierProduct.additional_percentage) / 100,
          1 + this.toNumber(supplierProduct.additional_percentage_1) / 100,
          1 - this.toNumber(supplierProduct.percentage_discount) / 100,
          1 - this.toNumber(supplierProduct.percentage_discount_1) / 100,
          1 - this.toNumber(supplierProduct.percentage_discount_2) / 100,
        ]
        for(var i = 0; i < factors.length; i++) {
          if(factors[i] <= 0) return null
          value = value / factors[i]
        }
        value = value - this.toNumber(supplierProduct.additional)
        return value > 0 ? value : null
      },
      addMultipleProduct(product, location) {
        if(this.requiresStockControl && !this.productControlsStock(product)) {
          return false
        }
        if(!location) {
          return false
        }

        var duplicate = this.crud.form.detail.some((item) => {
          return item.product && item.product.source == 'product' &&
            item.product.id == product.id && item.location && item.location.id == location.id
        })
        if(duplicate) {
          return false
        }

        // El selector de producto devuelve el artículo base; para que conserve
        // el mismo contrato que el alta individual se marca como fuente simple.
        this.$set(product, 'source', 'product')
        var arrItem = {
          product: product,
          quantity: 1,
          quantityOld: 0,
          unit_measurement: product.unit_measurement_purchase_default,
          location: this.cloneLocationWithoutContains(location),
          location_destination: null,
          purchase_orders_id: 0,
          purchase_orders_detail_id: 0,
          bulkCostSelected: false,
        }
        this.applyPurchasePricingToItem(arrItem, {selectProduct: product})
        this.crud.form.detail.push(arrItem)
        this.hydrateItemPricingFromCosts(arrItem)
        return true
      },
      cloneLocationWithoutContains(location) {
        var copy = Object.assign({}, location)
        delete copy.contains
        return copy
      },
      loadLocations (object) {        
        if(object){
          this.crud.form.detail_register.location = object
          this.crud.form.detail_register.location_id = object.id

          this.showAlertLocationsWithProductsDifferent(object)
        } else {
          this.crud.form.detail_register.location = null
          this.crud.form.detail_register.location_id = 0
        }
      },
      loadLocationsDestination (object) {
        if(object){
          this.crud.form.detail_register.location_destination = object
          this.crud.form.detail_register.location_destination_id = object.id

          this.showAlertLocationsWithProductsDifferent(object, true)
        } else {
          this.crud.form.detail_register.location_destination = null
          this.crud.form.detail_register.location_destination_id = 0
        }
      },

      // ALERT LOCATIONS
      showAlertLocationsWithProductsDifferent(location, showAlert=false) {
        if(!this.shouldWarnLocationWithDifferentProducts) {
          return
        }

        if(this.operation.reference == 'add-manual' || this.operation.selectTypeVoucher == 'remito' || showAlert) {
          var show = false
          if(this.crud.form.detail_register.selectedProduct) {
            if(!this.productControlsStock(this.crud.form.detail_register.selectedProduct)) {
              return
            }

            var source = this.crud.form.detail_register.selectedProduct.source
            var id = this.crud.form.detail_register.selectedProduct.id
            
            if(location.contains) {
              location.contains.forEach(element => {
                if(!(element['source'] == source && element['id'] == id)) {
                  show = true
                }
              });
            }
          }        
          if(show) {
            this.$awn.info("La ubicación seleccionada se encuentra ocupada por un producto diferente al seleccionado")
          }
        }
      },

      // SELECCION PRODUCTO-VARIEDAD 
      selectColorCombinado(item) {        
        this.crud.form.detail_register.color = item
        this.crud.form.detail_register.waist = null

        this.crud.form.detail_register.opt_waist = []
        var waistUnique = this.getWaistByColor          
        if(waistUnique) {
          waistUnique.forEach(element => {
            this.crud.form.detail_register.opt_waist.push({code: element.waist, label: element.waist.name})
          });
        }         
      },
      selectWaistCombinado(item) {
        this.crud.form.detail_register.waist = item
        this.selectedProduct()        
      },      
      selectColorSimple(item) {
        this.crud.form.detail_register.color = item
        this.selectedProduct()        
      },
      selectWaistSimple(item) {
        this.crud.form.detail_register.waist = item      
        this.selectedProduct()        
      },  

      // PRODUCTO/VARIEDAD SELCCIONADA
      selectedProduct() {        
        var variantSelect = null

        if(this.crud.form.detail_register.product) {
          if(this.haveOnlyProduct) {
            variantSelect = this.crud.form.detail_register.product
            variantSelect['source'] = 'product'
          } else {
            if(this.haveColorsWaist) {
              if(this.crud.form.detail_register.color && this.crud.form.detail_register.waist) {
                this.crud.form.detail_register.product.colors_waist.forEach(element => {                
                  if( element.colors_id == this.crud.form.detail_register.color.code.id && 
                      element.waist_id == this.crud.form.detail_register.waist.code.id ) {                                      
                      variantSelect = element                      
                      this.$set(variantSelect, 'control_stock', this.crud.form.detail_register.product.control_stock)
                      variantSelect['source'] = 'colors_waist'
                  }
                });
              }            
            } else {
              if(this.haveOnlyColors) {                
                if(this.crud.form.detail_register.color) {                  
                  this.crud.form.detail_register.product.colors.forEach(element => {                                       
                    if( element.colors_id == this.crud.form.detail_register.color.code.id ) {                                      
                        variantSelect = element                        
                        this.$set(variantSelect, 'control_stock', this.crud.form.detail_register.product.control_stock)
                        variantSelect['source'] = 'colors'
                    }
                  })
                }
              } else {
                if(this.haveOnlyWaist) {
                  if(this.crud.form.detail_register.waist) {
                    this.crud.form.detail_register.product.waist.forEach(element => {                   
                      if( element.waist_id == this.crud.form.detail_register.waist.code.id ) {                                      
                          variantSelect = element                          
                          this.$set(variantSelect, 'control_stock', this.crud.form.detail_register.product.control_stock)
                          variantSelect['source'] = 'waist'
                      }
                    })
                  }
                }            
              }          
            }     
          }             
        }

        if(variantSelect) {                    
          this.crud.form.detail_register.selectedProduct = variantSelect
        } else {                      
          this.crud.form.detail_register.selectedProduct = null
        }

        if(!this.requiresOriginLocation) {
          this.loadLocations(null)
        }

        this.crud.form.detail_register.selectProduct = this.getBaseProductForRow(this.crud.form.detail_register.selectedProduct)
        this.syncDetailRegisterPurchasePriceDefaults()
      }, 
      
      // ABM MAIN DETAILS
      addItem() {        
        // producto
        if(!this.crud.form.detail_register.selectedProduct) {
          this.$awn.alert('No se seleccionó el producto')          
          return false
        }

        if(this.requiresStockControl && !this.productControlsStock(this.crud.form.detail_register.selectedProduct)) {
          this.$awn.alert('El producto seleccionado no controla stock y no puede utilizarse en movimientos de depósito')
          return false
        }

        // cantidad
        if (this.crud.form.detail_register.quantity.toString() == '' || parseFloat(this.crud.form.detail_register.quantity)<=0) {
          this.$awn.alert('La cantidad debe ser mayor a cero')          
          return false
        }
                      
        // deposito/zona/ubicacion Origen
        if (this.requiresOriginLocation && !this.crud.form.detail_register.location) {
          this.$awn.alert('Falta seleccionar la ubicación')          
          return false
        }      
        
        // deposito/zona/ubicacion Destino
        if(this.operation.reference == 'transferencia') {
          if (!this.crud.form.detail_register.location_destination) {
            this.$awn.alert('Falta seleccionar la ubicación destino')          
            return false
          }              
        }
        
        // ubicación en transferencia
        if(!this.validDepositLocation()) {
          this.$awn.alert('La ubicación en depósito de salida no puede ser la misma que la ubicación de entrada') 
          return false          
        }

        // duplicados
        if(!this.validDuplicatedItem()) {
          this.$awn.alert('Item Duplicado') 
          return false          
        }

        let jsonLocation = JSON.stringify(this.crud.form.detail_register.location);
        let newJsonLocation = JSON.parse(jsonLocation, (key, value) => {
          if (key === 'contains') return undefined; 
          return value;
        });

        let jsonLocationDestination = JSON.stringify(this.crud.form.detail_register.location_destination);
        let newJsonLocationDestination = JSON.parse(jsonLocationDestination, (key, value) => {
          if (key === 'contains') return undefined; 
          return value;
        });        

        var arrItem = { 
          product: this.crud.form.detail_register.selectedProduct,
          quantity: parseFloat(this.crud.form.detail_register.quantity),
          quantityOld: parseFloat(this.crud.form.detail_register.quantityOld),          
          unit_measurement: this.crud.form.detail_register.unit_measurement,          
          location: newJsonLocation,
          location_destination: newJsonLocationDestination,
          purchase_orders_id: this.crud.form.detail_register.purchase_orders_id || 0,
          purchase_orders_detail_id: this.crud.form.detail_register.purchase_orders_detail_id || 0,
        }
        this.applyPurchasePricingToItem(arrItem, {
          price_cost: this.crud.form.detail_register.price_cost,
          selectProduct: this.crud.form.detail_register.selectProduct,
        })

        this.crud.form.detail.push(arrItem)
        this.$emit('load-detail', this.crud.form.detail)
        this.hydrateItemPricingFromCosts(arrItem)

        this.crud.form.detail_register.forceRenderSelectProduct = 0
        this.loadProducts(null)    
        
        this.crud.form.detail_register.button.editing = false
      },
      editItem (item, index) {    
        this.crud.form.detail_register.editing = true        
        this.crud.form.detail_register.quantity = item.quantity
        this.crud.form.detail_register.quantityOld = item.quantityOld        
        this.crud.form.detail_register.location = item.location || null
        this.crud.form.detail_register.location_id = item.location ? item.location.id : 0
        if(this.isSimpleProductItem(item)) {
          this.crud.form.detail_register.price_cost = parseFloat(item.price_cost || 0)
          this.crud.form.detail_register.selectProduct = item.selectProduct || this.getBaseProductForRow(item.product)
        } else {
          this.crud.form.detail_register.price_cost = 0
          this.crud.form.detail_register.selectProduct = null
        }
        this.crud.form.detail_register.purchase_orders_id = item.purchase_orders_id || 0
        this.crud.form.detail_register.purchase_orders_detail_id = item.purchase_orders_detail_id || 0
        
        if(item.location_destination) {
          this.crud.form.detail_register.location_destination = item.location_destination
          this.crud.form.detail_register.location_destination_id = item.location_destination.id        
        }
                                   
        if(item.product.source == 'product') {             
          this.crud.form.detail_register.product_id = item.product.id
          this.crud.form.detail_register.forceRenderSelectProduct = item.product.id      
          
          this.crud.form.detail_register.editing = false
        } else {          
          if(item.product.source == 'colors_waist') {
            this.crud.form.detail_register.product_id = item.product.products_id      
            this.crud.form.detail_register.forceRenderSelectProduct = item.product.products_id
            
            setTimeout(()=>{
              this.crud.form.detail_register.color = {code:item.product.color, label:item.product.color.name}
              this.selectColorCombinado(this.crud.form.detail_register.color)

              setTimeout(()=>{
                this.crud.form.detail_register.waist = {code:item.product.waist, label:item.product.waist.name}                
                this.selectWaistCombinado(this.crud.form.detail_register.waist)         
                
                this.crud.form.detail_register.editing = false
              },1000)              
            },1000)                        
          } else {
            if(item.product.source == 'colors') {
              this.crud.form.detail_register.product_id = item.product.products_id
              this.crud.form.detail_register.forceRenderSelectProduct = item.product.products_id
                                          
              setTimeout(()=>{                
                this.crud.form.detail_register.color = {code:item.product.color, label:item.product.color.name}
                this.selectColorSimple(this.crud.form.detail_register.color)        
                
                this.crud.form.detail_register.editing = false
              },1000)                            
            }
            if(item.product.source == 'waist') {
              this.crud.form.detail_register.product_id = item.product.products_id
              this.crud.form.detail_register.forceRenderSelectProduct = item.product.products_id
              
              setTimeout(()=>{                
                this.crud.form.detail_register.waist = {code:item.product.waist, label:item.product.waist.name}                
                this.selectWaistSimple(this.crud.form.detail_register.waist)     
                
                this.crud.form.detail_register.editing = false
              },1000)                            
            }
          }
        }

        setTimeout(()=>{
          this.crud.form.detail_register.unit_measurement = item.unit_measurement
          this.crud.form.detail_register.unit_measurement_id = item.unit_measurement.id           
        },500)

        this.crud.form.detail_register.button.title = "Editar Item"
        this.crud.form.detail_register.button.icon = "fa fa-save"
        this.crud.form.detail_register.button.variant = "warning"
        this.crud.form.detail_register.button.editing = true        
                             
        this.crud.form.detail.splice(index, 1)
        this.$emit('load-detail', this.crud.form.detail)
      },
      deleteItem (index) {
        this.crud.form.detail.splice(index, 1)
        this.$emit('load-detail', this.crud.form.detail)
      },
      
      // VALID DUPLICATED
      validDuplicatedItem() {
        var item = this.crud.form.detail_register.selectedProduct
        var location_id = this.crud.form.detail_register.location_id
        var status = true
        if(this.crud.form.detail) {
          this.crud.form.detail.forEach(element => {
            var elementLocationId = element.location ? element.location.id : 0
            if(element.product.source=='product') {
              if(element.product.id == item.id && elementLocationId == location_id) {
                status = false
              }              
            } 
            
            if(element.product.source=='colors_waist') {
              if(element.product.id == item.id &&
                 element.product.products_id == item.products_id && elementLocationId == location_id) {
                status = false
              }              
            }

            if(element.product.source=='colors') {
              if(element.product.id == item.id &&
                 element.product.products_id == item.products_id && elementLocationId == location_id) {
                   status = false
                 }              
            }

            if(element.product.source=='waist') {
              if(element.product.id == item.id &&
                 element.product.products_id == item.products_id && elementLocationId == location_id) {
                  status = false
              }              
            }
          });
        }
        return status
      },
      
      // VALID DEPOSIT / UBICACION EN TRANSFERENCIA
      validDepositLocation() {
        var status = true
        var value = this.crud.form.detail_register

        if(this.operation.reference == 'transferencia') {
          if(parseFloat(value.location_id) == parseFloat(value.location_destination_id)) {
            status = false
          }
        }
        
        return status
      }, 
      
      // LOAD EQUIVALENCES
      loadEquivalences() {        
        this.arr.equivalences = []

        if(this.crud.form.detail_register.selectedProduct) {                  
          var result = serviceAPI.obtenerEquivalencesAvailable({
            unit_measurement_id: this.crud.form.detail_register.selectedProduct.unit_measurement_purchase_default.id,
          })

          result.then((response) => {
            var data = response.data
            this.arr.equivalences = data
          })      
        }
      }, 
      setUnitMeasurementAlternative(element) {                
        this.crud.form.detail_register.unit_measurement = element
        this.crud.form.detail_register.unit_measurement_id = element.id                   
      },            
      getBaseProductForRow(item) {
        if(!item) {
          return null
        }

        if(item.source == 'product') {
          return item
        }

        return null
      },
      productControlsStock(item) {
        if(!item) {
          return true
        }

        var value
        if(Object.prototype.hasOwnProperty.call(item, 'control_stock')) {
          value = item.control_stock
        } else if(item.product && Object.prototype.hasOwnProperty.call(item.product, 'control_stock')) {
          value = item.product.control_stock
        } else if(this.crud.form.detail_register.product && Object.prototype.hasOwnProperty.call(this.crud.form.detail_register.product, 'control_stock')) {
          value = this.crud.form.detail_register.product.control_stock
        } else {
          return true
        }

        return !(value === false || value === 0 || value === '0' || value === 'false')
      },
      productItemControlsStock(item) {
        if(!item || !item.product) {
          return true
        }

        var product = item.product
        if(Object.prototype.hasOwnProperty.call(product, 'control_stock')) {
          var value = product.control_stock
          return !(value === false || value === 0 || value === '0' || value === 'false')
        }

        if(product.product && Object.prototype.hasOwnProperty.call(product.product, 'control_stock')) {
          var parentValue = product.product.control_stock
          return !(parentValue === false || parentValue === 0 || parentValue === '0' || parentValue === 'false')
        }

        return true
      },
      isSimpleProductItem(item) {
        return !!(item && item.product && item.product.source == 'product')
      },
      applyPurchasePricingToItem(item, source={}) {
        if(this.allowPurchasePricing && this.isSimpleProductItem(item)) {
          item.selectProduct = source.selectProduct || this.getBaseProductForRow(item.product)
          var pp = item.selectProduct ? item.selectProduct.product_purchase : null
          var supplierId = this.operation ? (this.operation.suppliers_id || 0) : 0

          // Si el product_purchase es de otro proveedor, no usarlo
          if(pp && supplierId && pp.suppliers_id && pp.suppliers_id != supplierId) {
            pp = null
            if(item.selectProduct) this.$set(item.selectProduct, 'product_purchase', null)
          }

          var defaultPrice = pp ? parseFloat(pp.price_list || pp.price_cost || 0) : 0

          // Para ítems de OC no usar el precio de la OC — el precio correcto viene del
          // módulo de costos para este proveedor (se actualiza al hidratar)
          var storedPrice = source.purchase_orders_detail_id ? 0 : parseFloat(source.price_cost || 0)
          item.price_cost = storedPrice || defaultPrice
          return item
        }

        item.price_cost = 0
        item.selectProduct = null
        return item
      },
      hydrateItemPricingFromCosts(item) {
        if(!this.allowPurchasePricing || !this.isSimpleProductItem(item)) return
        var product = item.selectProduct || this.getBaseProductForRow(item.product)
        var productId = product ? product.id : 0
        if(!productId) return
        var supplierId = this.operation ? (this.operation.suppliers_id || 0) : 0
        var cacheKey = productId + ':' + supplierId
        var cached = pricingCache[cacheKey]
        if(cached) {
          this.applyPricingPayloadToItem(item, cached)
          var items = Array.isArray(cached.suppliers_products) ? cached.suppliers_products : []
          var sp = supplierId ? items.find(r => r.suppliers_id == supplierId) : items.find(r => r.default) || items[0]
          if(sp) {
            var cost = parseFloat(sp.price_cost || sp.price_list || 0)
            if(cost) this.$set(item, 'price_cost', cost)
            this.$set(item, '_supplierNotLinked', false)
          } else if(supplierId) {
            this.$set(item, '_supplierNotLinked', true)
          }
          return
        }
        costsServiceAPI.cargarProductoCostosPorId({ product_id: productId })
          .then(response => {
            var data = response.data || {}
            pricingCache[cacheKey] = data
            this.applyPricingPayloadToItem(item, data)
            var list = Array.isArray(data.suppliers_products) ? data.suppliers_products : []
            var match = supplierId ? list.find(r => r.suppliers_id == supplierId) : list.find(r => r.default) || list[0]
            if(match) {
              var cost = parseFloat(match.price_cost || match.price_list || 0)
              if(cost) this.$set(item, 'price_cost', cost)
              this.$set(item, '_supplierNotLinked', false)
            } else if(supplierId) {
              this.$set(item, '_supplierNotLinked', true)
            }
          })
          .catch(() => {})
      },
      applyPricingPayloadToItem(item, payload) {
        if(!item || !item.selectProduct || !payload) return
        var product = payload.product || {}
        if(Array.isArray(product.prices)) this.$set(item.selectProduct, 'prices', product.prices)
        if(product.erp_iva_condition_id) this.$set(item.selectProduct, 'erp_iva_condition_id', product.erp_iva_condition_id)
        if(product.iva_condition) this.$set(item.selectProduct, 'iva_condition', product.iva_condition)
        var supplierId = this.operation ? (this.operation.suppliers_id || 0) : 0
        var supplierProducts = Array.isArray(payload.suppliers_products) ? payload.suppliers_products : []
        var supplierProduct = supplierId ? supplierProducts.find(row => row.suppliers_id == supplierId) : supplierProducts.find(row => row.default) || supplierProducts[0]
        if(supplierProduct) this.$set(item.selectProduct, 'product_purchase', supplierProduct)
      },
      syncDetailRegisterPurchasePriceDefaults() {
        if(!this.allowPurchasePricing) return
        var sp = this.getDetailRegisterSupplierProduct
        if(!this.crud.form.detail_register.button.editing) {
          var supplierId = this.operation ? (this.operation.suppliers_id || 0) : 0
          if(sp && supplierId && sp.suppliers_id && sp.suppliers_id != supplierId) {
            sp = null
          }
          this.crud.form.detail_register.price_cost = sp ? parseFloat(sp.price_list || sp.price_cost || 0) : 0
        }
      },
      formatCurrency(value) {
        return Intl.NumberFormat('es-AR',{style:'currency',currency:this.currency}).format(parseFloat(value || 0))
      },
      toNumber(value) {
        var n = parseFloat(value)
        return isNaN(n) ? 0 : n
      },            
    }
  }
</script>
<style>
  .crud-detail-product-search-row {
    gap: 4px;
  }
  .crud-detail-product-search-field {
    min-width: 0;
    position: relative;
  }
  .crud-detail-product-supplier-toggle.btn.list-view-icon-btn {
    margin-top: 29px;
    flex-shrink: 0;
  }
  .detail-bulk-cost-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    border: 1px solid #8bc5e8;
    border-left: 4px solid var(--app-color-primary);
    border-radius: 4px;
    background: #e9f7ff;
    box-shadow: 0 1px 3px rgba(32, 168, 216, 0.16);
  }
  .detail-bulk-cost-bar__label {
    font-size: 0.8rem;
    font-weight: 600;
    white-space: nowrap;
    color: #07577d;
  }
  .detail-bulk-cost-bar .form-control {
    max-width: 150px;
  }
  .detail-bulk-cost-bar__count {
    font-size: 0.78rem;
    color: var(--app-color-text-muted);
    margin-right: auto;
  }
  @media (max-width: 767.98px) {
    .detail-bulk-cost-bar {
      flex-wrap: wrap;
    }
    .detail-bulk-cost-bar .form-control {
      flex: 1 1 130px;
    }
  }
  .detail-deposit-product-stock-control {
    position: absolute;
    top: 2px;
    right: 0;
    z-index: 3;
    pointer-events: auto;
  }
  .detail-deposit-product-stock-control .badge {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 2px 5px;
    font-size: 9px;
    font-weight: var(--app-font-semibold);
    line-height: 1;
  }
  .detail-deposit-product-table-stock-control {
    display: inline-flex;
    align-items: center;
    margin-left: 6px;
    font-size: 14px;
    line-height: 1;
    vertical-align: middle;
    opacity: .58;
  }
  .detail-deposit-product-table-stock-control--active {
    color: var(--success);
  }
  .detail-deposit-product-table-stock-control--inactive {
    color: var(--secondary);
  }
  .crud-order-table-detail {
    overflow: auto;
    max-height: 350px;    
    min-height: 100px;    
  }
  .block-product-add {
    background: white;
    filter: brightness(0.4);
    border-radius: 15px;
    padding-top: 10px;
    pointer-events: none;
    opacity: 0.5;
  }
  .crud-new-orders-button-add {
    margin-top: 29px;
  }
  .crud-detail-deposit-product-fieldset fieldset {
    margin-bottom: 0 !important;
  }
  .crud-order-table-detail .deposit-destination-cell {
    padding-left: 14px !important;
  }
  .btn.crud-deposit-detail-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }
  .btn.crud-deposit-detail-action-toggle-labeled:hover,
  .btn.crud-deposit-detail-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  @media (max-width: 767.98px) {
    .crud-order-table-detail.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
    .crud-order-table-detail.app-table.b-table-stacked-md > tbody > tr > td:last-child {
      align-items: flex-start;
      padding-top: 10px !important;
    }
  }
  .p79-alert {
    font-size: 12px;
    padding: 8px 12px;
    border-radius: 4px;
  }
  .block-product-add-div {
    position: absolute;
    text-align: center;
    margin-top: 20px;    
  }  
</style>
